import { Layout as BaseLayout, Spin } from 'antd';
import { FC, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import NavMenu from './NavMenu';
import Sider from 'antd/es/layout/Sider';
import { Content } from 'antd/es/layout/layout';

const PublicLayout: FC = () => {
  return (
    <BaseLayout className="app">
      <Header />
      <BaseLayout className="privateContent">
        <Sider className={`sidebar`}>
          <NavMenu />
        </Sider>
        <BaseLayout className="privateCenter">
          <Content>
            <Suspense fallback={<Spin size={'large'} />}>
              <Outlet />
            </Suspense>
          </Content>
        </BaseLayout>
      </BaseLayout>
    </BaseLayout>
  );
};

export default PublicLayout;
